export const NumeroCondStyle = {
    backgroundColor: 'transparent',
    height: '25px',
    display: 'flex',
    justifyContent: "center",
    alignItems: 'center',
    cursor: 'pointer',
    color: 'white',
    borderBottom: '1px solid white',
    borderLeft: '1px solid white',
    borderRight: '1px solid white',
    "&:hover": { fontWeight: 700 }
    // border: '1px solid white'
}
